import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getEachInvestorsInvestment = async ({
  id,
  walletAccountId,
  investmentProductId,
}) => {
  if (investmentProductId && walletAccountId && id) {
    const queryParams = `?funderId=${Number(id)}&investmentProductId=${Number(
      investmentProductId
    )}&walletAccountId=${Number(walletAccountId)}`;

    const data = await getDataWithDotNet(
      `${ajaxEndpoints.INVESTORS_INVESTMENT}${queryParams}`
    );
    return data.data;
  }
};
export default function useEachInvestorsInvestment({
  id,
  walletAccountId,
  investmentProductId,
}) {
  return useQuery(
    [
      { id, walletAccountId, investmentProductId },
      "getEachInvestorsInvestment",
    ],
    getEachInvestorsInvestment,
    {
      refetchOnWindowFocus: false,
    }
  );
}
